import React from 'react';
import { connect } from 'react-redux';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { setSessionVar, updateLegacySessionKey } from '../../store/actions';
import {
  pullCampaignSites,
  updateOrCreateSite,
  pullSiteNotes,
  pullSiteNoteCategories,
} from '../../store/api/calls';
import api from '../../store/api/api';

import { updateCampaignAggregates, getFocusedCampaign } from '../../store/api/calls';
import { siteEditForm } from '../../utils/forms/formFields';

import NavBaseTemplate from '../templates/NavBaseTemplate';
import BaseForm from '../theme/forms/BaseForm';
import DataTable from '../theme/tables/DataTable';
import Input from '../theme/forms/Input';
import Modal from 'react-responsive-modal';
import Moment from 'moment';
import FeedbackTile from '../theme/modals/FeedbackTile';
import BaseModal from '../theme/modals/BaseModal';

import * as formFields from '../../utils/forms/formFields';
import RowCard from '../cards/rowCard';
import { get as _get } from 'lodash';
import ImageViewBox from '../imgs/imageViewBox';
import ImageThumbnail from '../imgs/thumbnail';
import SiteNoteModal from '../theme/modals/SiteNoteModal';
import NoteTagList from '../theme/buttons/NoteTag';
import { Link } from 'react-router-dom';

class SiteScreen extends React.Component {
  // static propTypes = {
  // 	cookies: instanceOf(Cookies).isRequired
  // };

  constructor(props) {
    super(props);

    const { cookies } = props;
    this.state = {
      editModalOpen: false,
      deleteModalOpen: false,
      showAdHoc: false,
      editingInstance: {},
      noteModalOpen: false,
      errMsg: null,
    };

    this.formInputs = [
      formFields.genericName,
      formFields.genericDescription,
      formFields.addressLine1,
      formFields.addressLine2,
      formFields.city,
      formFields.state,
      { ...formFields.zipcode, dataKey: 'zip5' },
    ];
  }

  componentDidMount() {
    const legacyCookie = this.props.cookies.get('sessionid_wox_legacy');
    this.props.updateLegacySessionKey(legacyCookie);

    pullCampaignSites({ filter_ad_hoc: 0, notes: 1 });
  }

  componentDidUpdate(prevProps) {
    if (this.props.focusedCampaign !== prevProps.focusedCampaign) {
      pullCampaignSites({ filter_ad_hoc: 0, notes: 1 });
    }
  }

  _isError = () => {
    return this.state.errorMsg || this.props.error;
  };

  _setErrMsg = (msg) => {
    this.setState({ errMsg: msg }, () => setTimeout(() => this.setState({ errMsg: null }), 3000));
  };

  buildInputsWithPrepopulatedFields = (modelInstance) => {
    this.formInputs.forEach((d) => {
      d.value = modelInstance[d.dataKey];
    });
  };

  _filterKeysForDataTable() {
    let { sites } = this.props;

    let mapping = (d) => {
      let fields = {
        notes: (
          <div className={'notes-in-table'} onClick={() => this.onOpenNoteModal(d)}>
            <NoteTagList notes={d.notes} addButton={true} />
          </div>
        ),
        name: (
          <b className={'primary-text'} style={{ maxWidth: '200px' }}>
            {d.name}
          </b>
        ),
        _name: d.name,
        description: d.description,
        address: d.addressline2 ? d.addressline1 + ', ' + d.addressline2 : d.addressline1,
        city: d.city,
        state: d.statecode,
        zip: d.zip5,
        created_on: new Moment(d.created_at).add(Moment().utcOffset(), 'm').format('MM/DD/YY'),
        _created_on: new Moment(d.created_at),
        _data: d,
      };

      if (this.state.showAdHoc) {
        fields = {
          ...fields,
          site_type: d.site_type,
          ad_hoc_date: d.ad_hoc_date
            ? new Moment(d.ad_hoc_date, 'YYYY-MM-DD').format('MM/DD/YY')
            : null,
          _ad_hoc_date: new Moment(d.ad_hoc_date, 'YYYY-MM-DD'),
        };
      }

      return fields;
    };

    if (!this.state.showAdHoc) {
      sites = sites.filter((d) => d.site_type !== 'ad_hoc');
    }

    return sites.map(mapping);
  }

  onOpenEditModal = (modelInstance = {}) => {
    this.buildInputsWithPrepopulatedFields(modelInstance);
    this.setState({ editModalOpen: true, editingInstance: modelInstance });
  };

  onCloseEditModal = () => {
    this.setState({ editModalOpen: false, editingInstance: {} });
  };

  onOpenDeleteModal = (modelInstance) => {
    this.setState({ deleteModalOpen: true, editingInstance: modelInstance });
  };

  onCloseDeleteModal = () => {
    this.setState({ deleteModalOpen: false });
  };

  onOpenNoteModal = (modelInstance = {}) => {
    console.log('onOpenNoteModal', modelInstance);
    this.props.setSiteNoteModalSite(modelInstance);
  };

  getNotesForSite = (site_id) => {
    return this.props.siteNotes
      .filter((d) => d.site === site_id)
      .map((d) => ({
        ...d.note,
        id: d.id,
        category: d.note.category.name,
        color: d.note.category.color,
      }));
  };

  onRemoveNote = (modelInstance) => {
    api
      .patch(`sitenotes/${modelInstance.id}/`, { is_active: false })
      .then(() => {
        this.setState({
          notes: this.props.siteNotes.filter((n) => n.id !== modelInstance.id),
        });
      })
      .catch(() => {
        this._setErrMsg('A problem occurred, the note was not removed.');
      });
  };

  handleUpdateCreateSubmission = (data) => {
    console.log('data', data);
    const id = this.state.editingInstance.id;
    const campaign = this.props.focusedCampaign.id;
    if (id) data = { ...data, id };

    data = { ...data, campaign };
    updateOrCreateSite(data).then(this.onCloseEditModal());
  };

  handleRemoveSubmission = () => {
    const id = this.state.editingInstance.id;
    const data = { is_active: false, id };

    updateOrCreateSite(data).then(this.onCloseDeleteModal());
  };

  render() {
    return (
      <NavBaseTemplate location={this.props.location} showAdmin={this.props.is_admin}>
        <h3>Sites</h3>
        <div className="button-table-top-wrapper">
          <Link to={'/site'}>
            <a className="button" onClick={() => null}>
              Map View
            </a>
          </Link>
          <a className="button primary" onClick={() => this.props.history.push('create-site')}>
            + Create Site
          </a>
          <Input
            type="checkbox"
            value={this.state.showAdHoc}
            onChange={() => {
              this.setState({ showAdHoc: !this.state.showAdHoc });
            }}
            title="Show Ad Hoc Sites"
          />
        </div>
        <DataTable
          data={this._filterKeysForDataTable() || []}
          title="Sites"
          actions={[
            {
              title: 'edit',
              icon: 'fa-edit',
              action: (modelInstance) => this.onOpenEditModal(modelInstance),
            },
            {
              title: 'delete',
              icon: 'fa-minus-square',
              action: (modelInstance) => this.onOpenDeleteModal(modelInstance),
            },
          ]}
        />

        <SiteNoteModal showCloseIcon center />

        <BaseModal open={this.state.editModalOpen} onClose={this.onCloseEditModal} center>
          <BaseForm
            title={`Edit ${this.state.editingInstance.name}`}
            inputs={this.formInputs}
            onCancel={this.onCloseEditModal}
            onSubmit={this.handleUpdateCreateSubmission}
          />
        </BaseModal>

        <BaseModal open={this.state.deleteModalOpen} onClose={this.onCloseDeleteModal} center>
          <div className="modal-internal-wrapper">
            <p>
              Are you sure you want to remove the site <b>{this.state.editingInstance.name}</b>?
            </p>
            <div className="button-wrapper">
              <div className="button" onClick={this.handleRemoveSubmission}>
                Remove
              </div>
              <div className="button button-outline" onClick={this.onCloseDeleteModal}>
                Cancel
              </div>
            </div>
          </div>
        </BaseModal>

        <FeedbackTile
          text={
            <div>
              <i className=" fas fa-asterisk fa-spin" style={{ marginRight: '15px' }} />
              Loading...
            </div>
          }
          visible={this.props.loading}
        />

        <FeedbackTile
          text={
            <div>
              <i className="fas fa-exclamation-triangle" style={{ marginRight: '15px' }} />
              {this.props.error || 'There was a server error.'}
            </div>
          }
          visible={this._isError()}
          classNames="danger"
        />

        <ImageViewBox />
      </NavBaseTemplate>
    );
  }
}

const mapStateToProps = (state) => ({
  campaigns: state.session.campaigns,
  focusedCampaign: state.session.focusedCampaign,
  sites: state.sites.data,
  loading: state.sites.loading || state.siteNotes.loading,
  error: state.sites.error || state.siteNotes.error,
  is_admin: state.permissions.is_admin,
  siteNotes: state.siteNotes.data,
  noteCategories: state.siteNotes.categories,
});

const mapDispatchToProps = (dispatch) => ({
  updateLegacySessionKey: (key) => dispatch(updateLegacySessionKey(key)),
  setSiteNoteModalSite: (siteObj) => dispatch(setSessionVar('siteNoteModalSite', siteObj)), //if set, modal visible. siteObj is null hides modal
});

export default connect(mapStateToProps, mapDispatchToProps)(withCookies(SiteScreen));
